export default "__VITE_ASSET__CdK403HK__"